var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterTwitterImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.834,
    height: 16.931,
    viewBox: "0 0 20.834 16.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-twitter",
    d: "M20.775,7.621a8.55,8.55,0,0,1-2.457.674A4.285,4.285,0,0,0,20.2,5.931a8.583,8.583,0,0,1-2.715,1.036,4.276,4.276,0,0,0-7.282,3.9A12.137,12.137,0,0,1,1.391,6.4a4.284,4.284,0,0,0,1.323,5.709,4.271,4.271,0,0,1-1.937-.536v.054a4.28,4.28,0,0,0,3.428,4.192,4.278,4.278,0,0,1-1.125.149,4.118,4.118,0,0,1-.805-.078,4.284,4.284,0,0,0,3.993,2.97A8.569,8.569,0,0,1,.959,20.687a8.409,8.409,0,0,1-1.018-.06,12.077,12.077,0,0,0,6.552,1.921,12.078,12.078,0,0,0,12.162-12.16c0-.185,0-.372-.011-.554A8.689,8.689,0,0,0,20.775,7.621Z",
    transform: "translate(0.059 -5.617)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitterImg);
export default __webpack_public_path__ + "static/media/footerTwitterImg.ec82b3d3cc93d652f4d3295a8a0d2a68.svg";
export { ForwardRef as ReactComponent };